import { CollectionJobs, CollectionPros, HomeMain, NewsAboutUs } from "../../widget";

export const HomePage = () => (
    <>
        <HomeMain />
        <CollectionJobs />
        <CollectionPros />
        <NewsAboutUs />
    </>
);
